const MyOrders = () => {
  if (document.querySelectorAll('[data-section-type="INF-MyOrders"]').length === 0) {
    return;
  }

  document.addEventListener('click', (e) => {
    const button = e.target.closest('[data-view-order-details-button]');
    if (button) {
      const collapsedText = button.querySelector('[data-collapsed-text]');
      const expandedText = button.querySelector('[data-expanded-text]');
      const order = button.closest('[data-order]');
      const orderDetails = order.querySelector('[data-order-details]');

      if (orderDetails.classList.contains('Order__expanded-info--open')) {
        collapsedText.style.display = 'block';
        expandedText.style.display = 'none';
        orderDetails.classList.remove('Order__expanded-info--open');
        orderDetails.style.maxHeight = '0';
        return;
      }

      collapsedText.style.display = 'none';
      expandedText.style.display = 'block';
      orderDetails.classList.add('Order__expanded-info--open');
      orderDetails.style.maxHeight = `${orderDetails.querySelector('[data-order-details-height]').offsetHeight}px`;
    }
  });

  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-view-order-details-link]');
    if (link) {
      const order = link.closest('[data-order]');
      const button = order.querySelector('[data-view-order-details-button]');
      if (button) {
        button.click();
      }
    }
  });

  // On page load, open your most recent order automatically on desktop
  // if (window.theme.breakpoints.current !== 'mobile') {
  //   document.querySelectorAll('[data-view-order-details-button]')[0].click();
  // }

  // If the order info is expanded, double click the button to resize it when the browser resizes.
  window.addEventListener('resize', () => {
    document.querySelectorAll('.Order__expanded-info--open').forEach((expanded) => {
      const order = expanded.closest('[data-order]');
      const button = order.querySelector('[data-view-order-details-button]');
      if (button) {
        button.click();
        button.click();
      }
    });
  });
};

export { MyOrders };
